import ToHomeButton from "../buttons/ToHomeButton";
import NavigateButton from "../buttons/NavigateButton";
import ModelSelecter from "../buttons/ModelSelecter";
import DrawingViewer from "../DrawingViewer";
import ModelViewer from "../ModelViewer";
import React, { useState, useEffect } from 'react';

function Suggest() {
  const [errorGlbPath, setErrorGlbPath] = useState("model1");
  const [cameraPosition] = useState({ x: 0, y: 125, z: -485 });
  const shearValue = 0.3;
  const [motifGlbPath, setMotifGlbPath] = useState(() => ("model"));

  useEffect(() => {
    // Suggest uses a fixed motif; keep logic for cube1 if needed in future
    setMotifGlbPath("model");
  }, []);

  return (
    <div className="page">
      <h1 className="heading-hero mb-6">修正過程画面</h1>

      <div className="section-row">
        <div className="col-third">
          <h2 className="heading-lg mb-2">モチーフ</h2>
          <h3 className="text-subtitle mb-1">デッサン</h3>
          <DrawingViewer glbPath="model" caption="左" canvasId="leftDrawingCanvas" />
          <h3 className="text-subtitle mt-3 mb-1">3Dモデル</h3>
          <ModelViewer
            glbPath={motifGlbPath}
            imagePath={`./drawing/${motifGlbPath}.png`}
            caption="左"
            canvasId="leftModelCanvas"
            cameraPosition={cameraPosition}
          />
        </div>

        <div className="col-third">
          <h2 className="heading-lg mb-2">中間</h2>
          <h3 className="text-subtitle mb-1">デッサン</h3>
          <DrawingViewer
            glbPath={errorGlbPath}
            caption="中間"
            canvasId="ProcessDrawingCanvas"
            shearValue={shearValue}
          />
          <h3 className="text-subtitle mt-3 mb-1">3Dモデル</h3>
          <ModelViewer
            glbPath={errorGlbPath}
            caption="モチーフ+2"
            canvasId="ProcessModelCanvas"
            shearValue={shearValue}
            cameraPosition={cameraPosition}
          />
        </div>

        <div className="col-third">
          <h2 className="heading-lg mb-2">誤り</h2>
          <h3 className="text-subtitle mb-1">デッサン</h3>
          <DrawingViewer glbPath={errorGlbPath} caption="右" canvasId="rightDrawingCanvas" />
          <h3 className="text-subtitle mt-3 mb-1">3Dモデル</h3>
          <ModelViewer
            glbPath={errorGlbPath}
            imagePath="./drawing/model1.png"
            caption="右"
            canvasId="rightModelCanvas"
            cameraPosition={cameraPosition}
          />
        </div>
      </div>

      <div className="row-center mt-6">
        <ModelSelecter errorGlbPath={errorGlbPath} setErrorGlbPath={setErrorGlbPath} />
      </div>

      <div className="row-center mt-6">
        <ToHomeButton buttonText="Home画面に戻る" />
        <NavigateButton to="/correction" buttonText="誤りに気が付いた" className="btn--danger" />
        <NavigateButton to="/viewer" buttonText="二次元画像との比較画面へ遷移" />
        <NavigateButton to="/viewer2" buttonText="デッサンとの比較画面へ遷移" />
      </div>
    </div>
  );
}

export default Suggest;